<template>
	<view class="index">
		<!-- <view class="zhezhao"></view> -->
		<view class="head">
			<view class="head-title">
				<view class="head-title-left" @click="jumpList">
					<image src="/static/ic_paihang@2x.png" mode="widthFix"></image>
					<text>排行榜</text>
				</view>
				<view class="head-title-name">选择点将老师</view>
				<view class="head-title-left" style="opacity: 0;">
					<image src="/static/ic_paihang@2x.png" mode="widthFix"></image>
					<text>排行榜</text>
				</view>
			</view>
			<view class="head-search">
				<view class="head-search-input">
					<u-search placeholder="请输入老师姓名" height="36" :showAction="false"></u-search>
				</view>
				<view class="cate">
					<view class="cate-item">
						<text>商业化类型</text>
						<image src="/static/ar_open7@2x.png" mode="widthFix"></image>
					</view>
					<view class="cate-item">
						<text>擅长领域</text>
						<image src="/static/ar_open7@2x.png" mode="widthFix"></image>
					</view>
					<view class="cate-item">
						<text>默认排序</text>
						<image src="/static/ar_open7@2x.png" mode="widthFix"></image>
					</view>
				</view>
				<!-- <view class="sou">
					<view class="sou-cate">
						<view class="sou-cate-item active">培训提成</view>
						<view class="sou-cate-item">谈单成交</view>
						<view class="sou-cate-item">主动营销</view>
					</view>
					<view class="sou-list">
						<view class="sou-list-item">
							<text :style="{ color: '#2E68C4' }">获客类</text>
							<image src="/static/ic_selete@2x.png" mode="widthFix"></image>
						</view>
						<view class="sou-list-item"><text>市场类</text></view>
						<view class="sou-list-item"><text>设计类</text></view>
						<view class="sou-list-item"><text>培训类</text></view>
					</view>
				</view> -->
			</view>
		</view>
		<view class="list">
			<view class="item" v-for="(item, index) in 10" :key="index" @click="jump">
				<view class="item-tx">
					<image src="/static/logo.png" mode="widthFix"></image>
				</view>
				<view class="item-info">
					<view class="item-info-a">
						<text>刘永慧</text>
						<text>P6｜销售培训师</text>
					</view>
					<view class="item-info-b">
						<view class="item-info-b-row">市场类</view>
						<view class="item-info-b-row">获客类</view>
						<view class="item-info-b-row">培训类</view>
					</view>
					<view class="item-info-c">
						<view class="item-info-c-item">
							<view class="item-info-c-item-label">从业年限：</view>
							<view class="item-info-c-item-val">10年</view>
						</view>
						<view class="item-info-c-item">
							<view class="item-info-c-item-label">近半年服务商场数：</view>
							<view class="item-info-c-item-val">38个</view>
						</view>
					</view>
					<view class="item-info-d">
						从事设计商业化已有多年，擅长各种风格，服务大客户超过50户…<text>更多</text>
					</view>
					<view class="item-info-price">
						<text>标准收费</text>
						<text>2900</text>
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		onLoad() {

		},
		methods: {
			jump() {
				uni.navigateTo({
					url: '/pages/details/details'
				})
			},
			jumpList() {
				uni.navigateTo({
					url: '/pages/ranking-list/ranking-list'
				})
			}
		}
	}
</script>

<style>
	page {
		background-color: #f7f7f7;
	}
</style>
<style lang="scss" scoped>
	.index {
		width: 100%;
		.list {
			width: 100%;
			padding: 20rpx 30rpx;
			box-sizing: border-box;
			.item {
				width: 100%;
				background: #FFFFFF;
				border-radius: 8rpx;
				padding: 24rpx;
				box-sizing: border-box;
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				margin-bottom: 20rpx;
				&:last-child {
					margin: 0 !important;
				}
				.item-tx {
					flex-shrink: 0;
					width: 128rpx;
					height: 168rpx;
					border-radius: 8rpx;
					overflow: hidden;
					margin-right: 20rpx;
					image {
						width: 100%;
					}
				}
				.item-info {
					flex: 1;
					display: flex;
					flex-direction: column;
					position: relative;
					.item-info-price {
						position: absolute;
						right: 0;
						top: 0;
						display: flex;
						align-items: flex-end;
						flex-direction: column;
						text {
							&:nth-child(1) {
								font-weight: 400;
								font-size: 22rpx;
								color: #FF7000;
							}
							&:nth-child(2) {
								font-weight: 600;
								font-size: 30rpx;
								color: #FF7000;
								&::after {
									content: "元/周";
									font-weight: 600;
									font-size: 20rpx;
									color: #FF7000;
								}
							}
						}
					}
					.item-info-a {
						display: flex;
						align-items: center;
						text {
							&:nth-child(1) {
								font-weight: 600;
								font-size: 30rpx;
								color: #222222;
							}
							&:nth-child(2) {
								font-weight: 400;
								font-size: 24rpx;
								color: #777777;
								margin-left: 10rpx;
							}
						}
					}
					.item-info-b {
						display: flex;
						flex-wrap: wrap;
						align-items: center;
						margin-top: 8rpx;
						.item-info-b-row {
							padding: 0 8rpx;
							box-sizing: border-box;
							height: 40rpx;
							line-height: 40rpx;
							border-radius: 8rpx;
							border: 1rpx solid #2E68C4;
							font-weight: 400;
							font-size: 22rpx;
							color: #2E68C4;
							margin-right: 8rpx;
							&:last-child {
								margin: 0;
							}
						}
					}
					.item-info-c {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-top: 20rpx;
						.item-info-c-item {
							display: flex;
							align-items: center;
							.item-info-c-item-label {
								font-weight: 400;
								font-size: 24rpx;
								color: #777777;
							}
							.item-info-c-item-val {
								font-weight: 400;
								font-size: 24rpx;
								color: #333333;
							}
						}
					}
					.item-info-d {
						width: 100%;
						font-weight: 400;
						font-size: 24rpx;
						color: #333333;
						margin-top: 20rpx;
						text {
							color: #2E68C4;
						}
					}
				}
			}
		}
		.zhezhao {
			width: 100vw;
			height: 100vh;
			position: fixed;
			top: 0;
			left: 0;
			z-index: 5;
			background-color: rgba(0,0,0,.5);
		}
		.head {
			width: 100%;
			height: 260rpx;
			position: sticky;
			top: 0;
			left: 0;
			z-index: 9;
			background-color: #ffffff;
			.head-title {
				width: 100%;
				height: 88rpx;
				padding: 0 30rpx;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.head-title-left {
					display: flex;
					align-items: center;
					image {
						width: 40rpx;
						height: 40rpx;
					}
					text {
						font-weight: 400;
						font-size: 26rpx;
						color: #2E68C4;
						margin-left: 8rpx;
					}
				}
				.head-title-name {
					font-weight: 500;
					font-size: 32rpx;
					color: #111111;
				}
			}
			.head-search {
				width: 100%;
				height: 172rpx;
				.head-search-input {
					width: 100%;
					padding: 0 30rpx;
					box-sizing: border-box;
					height: 72rpx;
					margin-top: 12rpx;
				}
				.sou {
					width: 100%;
					padding: 0 30rpx;
					box-sizing: border-box;
					border-radius: 0 0 30rpx 30rpx;
					background-color: #ffffff;
					.sou-cate {
						width: 100%;
						padding: 0 0 30rpx 0;
						box-sizing: border-box;
						display: flex;
						align-items: center;
						justify-content: space-between;
						.active {
							background: rgba(46,104,196,0.1) !important;
							color: #2E68C4 !important;
						}
						.sou-cate-item {
							width: 216rpx;
							height: 72rpx;
							line-height: 72rpx;
							text-align: center;
							background: #F7F7F7;
							border-radius: 8rpx;
							font-weight: 400;
							font-size: 28rpx;
							color: #333333;
						}
					}
					.sou-list {
						width: 100%;
						display: flex;
						flex-direction: column;
						.sou-list-item {
							width: 100%;
							height: 96rpx;
							display: flex;
							align-items: center;
							justify-content: space-between;
							border-bottom: 1rpx solid #EEEEEE;
							text {
								font-weight: 400;
								font-size: 28rpx;
								color: #222222;
							}
							image {
								width: 24rpx;
								height: 18rpx;
							}
						}
					}
				}
				.cate {
					width: 100%;
					height: 88rpx;
					padding: 0 30rpx;
					box-sizing: border-box;
					display: flex;
					align-items: center;
					.cate-item {
						flex: 1;
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						text {
							font-weight: 400;
							font-size: 26rpx;
							color: #777777;
							margin-right: 8rpx;
						}
						image {
							width: 20rpx;
							height: 20rpx;
						}
					}
				}
			}
		}
	}
</style>
